import { render, staticRenderFns } from "./Unsupport.vue?vue&type=template&id=cf4ef852&scoped=true&"
import script from "./Unsupport.vue?vue&type=script&lang=js&"
export * from "./Unsupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf4ef852",
  null
  
)

export default component.exports